module.exports = __webpack_public_path__ + "img/header_bg.8f19fa9b.jpg";